export default "__VITE_ASSET__CeQk3$Ox__"